import { API } from "../urls";

const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: 'include' };

// Kullanıcı sil (admin)
export const deleteUser = async (userId) => {
    const res = await fetch(API.admin_user(userId), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Silme başarısız");
    }
    return res.json();
};
